import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0516ce2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./style/index.scss?vue&type=style&index=0&id=0516ce2a&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=0516ce2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516ce2a",
  null
  
)

export default component.exports